// extracted by css-extract-rspack-plugin
export default {"scrollWrapper":"Table__scrollWrapper--dFhCC"};